import React, { ReactElement } from 'react';
import SwipeableSlider from '../swipeable-slider/swipeable-slider.component';
import FlexContainer from '../flex-container/flex-container.component';
import FilteredLink from '../filtered-link/filtered-link.component';
import Image from '../image/image.component';
import Button from '../button/button.component';
import useScreenSmall from '../../hooks/use-screen-small';
import useScreenMobile from '../../hooks/use-screen-mobile';
import useStylesWidgetImageSliderSimple from './widget-image-slider-simple.styles';

const WidgetImageSliderSimple: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const SLIDES_PER_VIEW_MOBILE: number = 1;
  const SLIDE_ITEM_WIDTH: number = 400;

  const {
    imageList,
    imageTextPrefix,
    onSlideClick,
  } = props;

  const { classes } = useStylesWidgetImageSliderSimple();
  const isSmallScreen: boolean = useScreenSmall();
  const isMobileScreen: boolean = useScreenMobile();

  return (
    <SwipeableSlider
      isCentered
      withNoOffset
      withControlsVisible
      withLightControls
      withTransparentControls
      slideItemWidth={!isMobileScreen ? SLIDE_ITEM_WIDTH : undefined}
      slidesPerView={isMobileScreen ? SLIDES_PER_VIEW_MOBILE : undefined}
    >
      {
        imageList.map((imageItem: SliderImageItem): ReactElement => (
          <FlexContainer isColumn key={imageItem.id} className={classes.widgetImageSliderSimpleItem}>
            {
              isSmallScreen && (
                <div className={classes.widgetImageSliderSimpleItemImageBlock}>
                  <FilteredLink isExternal link={imageItem.link}>
                    <Image
                      isDefault
                      text={`${imageTextPrefix}${imageItem.id}`}
                      link={imageItem.link}
                      className={classes.widgetImageSliderSimpleItemImage}
                    />
                  </FilteredLink>
                </div>
              )
            }
            {
              !isSmallScreen && (
                <Button
                  isText
                  isDefault
                  className={classes.widgetImageSliderSimpleItemImageBlock}
                  onClick={(): void => {
                    onSlideClick(imageItem.id);
                  }}
                >
                  <Image
                    isDefault
                    text={`${imageTextPrefix}${imageItem.id}`}
                    link={imageItem.link}
                    className={classes.widgetImageSliderSimpleItemImage}
                  />
                </Button>
              )
            }
          </FlexContainer>
        ))
      }
    </SwipeableSlider>
  );
});

export default WidgetImageSliderSimple;
